/* Small helpers for the redesign's components. */

export function initials(name: string) {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join('')
    .toUpperCase()
}

/** Healthy from 70, worth watching from 45, at risk below. */
export const healthBand = (h: number) => (h >= 70 ? 'good' : h >= 45 ? 'mid' : 'low')
